import { atom } from "jotai";

export const isSummaryModalAtom = atom(false);

export const isSummaryViewAtom = atom(false);
